import React from 'react';
import { useNavigate } from 'react-router-dom';

interface PremiumLimitModalProps {
  isOpen: boolean;
  onClose: () => void;
  message: React.ReactNode;
  premiumMessage: React.ReactNode;
  ctaLabel?: string;
  ctaTarget?: 'subscription' | 'overages';
  closeLabel?: string;
}

export const PremiumLimitModal: React.FC<PremiumLimitModalProps> = ({
  isOpen,
  onClose,
  message,
  premiumMessage,
  ctaLabel = 'Découvrir les offres Premium',
  ctaTarget = 'subscription',
  closeLabel = "Continuer avec l'offre gratuite",
}) => {
  const navigate = useNavigate();

  if (!isOpen) {
    return null;
  }

  const handleUpgrade = () => {
    onClose();

    navigate('/account', {
      state: {
        activeTab: ctaTarget,
      },
    });
  };

  return (
    <div className="modal-overlay">
      <div className="modal">
        <h2>Limite atteinte</h2>

        <p>{message}</p>

        <p>{premiumMessage}</p>

        <div className="modal-actions">
          <button
            className="btn btn-primary"
            onClick={handleUpgrade}
          >
            {ctaLabel}
          </button>

          <button
            className="btn btn-secondary"
            onClick={onClose}
          >
            {closeLabel}
          </button>
        </div>
      </div>
    </div>
  );
};